import * as htmlToImage from 'html-to-image'
import download from 'downloadjs'

export const downloadReportImage = (nodeId, reportName) => {
    htmlToImage.toPng(document.getElementById(nodeId), {backgroundColor : 'white'})
        .then(function (dataUrl) {
            download(dataUrl, reportName+'.png');
    });
}